export default (phoneNumber) => 
  `(${phoneNumber.substr(0, 3)}) ${phoneNumber.substr(3, 3)} - ${phoneNumber.substr(6)}`;